export const WELCOME_SESSION_KEY = 'untangled:welcome-seen:v1';

type SessionStorage = Pick<Storage, 'getItem' | 'setItem'>;

// Only the existing homepage can be the continuation target. Never accept an
// external destination or intercept checkout, authentication, or campaign links.
export function welcomeHomeHref(value?: string | null): string {
  if (!value?.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/';
  try {
    const url = new URL(value, 'https://welcome.invalid');
    return url.origin === 'https://welcome.invalid' && url.pathname === '/'
      ? `/${url.search}${url.hash}`
      : '/';
  } catch {
    return '/';
  }
}

export function claimWelcomeEntry(storage: SessionStorage, pathname: string): boolean {
  if (pathname !== '/') return false;
  try {
    if (storage.getItem(WELCOME_SESSION_KEY)) return false;
    // Write before navigating so Back, reload and repeated effects cannot loop.
    storage.setItem(WELCOME_SESSION_KEY, '1');
    return true;
  } catch {
    return false;
  }
}

export function markWelcomeSeen(): void {
  try {
    window.sessionStorage.setItem(WELCOME_SESSION_KEY, '1');
  } catch {
    // The existing website remains usable when storage is unavailable.
  }
}
